import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography } from '@mui/material';

function EventTable() {
  const [events, setEvents] = useState([]);

  useEffect(() => {
    fetchEvents();
  }, []);

  const fetchEvents = async () => {
    try {
      const response = await axios.get('http://65.109.29.230:3001/events');
      setEvents(response.data);
    } catch (error) {
      console.error('Error fetching events:', error);
    }
  };

  return (
    <div style={{
      marginTop: "120px",
    }}>
      <Typography variant="h5" gutterBottom>
        Event Table
      </Typography>
      <TableContainer style={{
      marginTop: "15px",
    }}component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="event table">
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Username</TableCell>
              <TableCell>Action</TableCell>
              <TableCell>Table Name</TableCell>
              <TableCell>Record ID</TableCell>
              <TableCell>Timestamp</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {events.map((event) => (
              <TableRow
                key={event.id}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  {event.id}
                </TableCell>
                <TableCell>{event.username}</TableCell>
                <TableCell>{event.action}</TableCell>
                <TableCell>{event.table_name}</TableCell>
                <TableCell>{event.record_id}</TableCell>
                <TableCell>{new Date(event.timestamp).toLocaleString()}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

export default EventTable;